import createScrollOpt from "@/assets/js/vuescrollOption";
import { highClassLevelList ,enroll_type_list, classLevelListForCoachAndGoalkepper } from "@/assets/js/select";
import commonFun from "@/assets/js/yioks";
import { storageData } from "@/assets/js/storage";

const { mobile_phone, email } = commonFun;

export default {
  created() {
  },
  data() {
    const editorOption = {
      placeholder: '请填写说明',
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "blockquote"],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ color: [] }, { background: [] }],
          [
            { size: ["small", false, "large", "huge"] },
            { header: [1, 2, 3, 4, 5, 6, false] }
          ],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["clean"]
        ]
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (value!=='') {
        callback();
      } else {
        callback(new Error("请输入电话"));
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback();
        return;
      }
      if (email(value)) {
        callback();
      } else {
        callback(new Error("请输入格式正确的邮箱"));
      }
    };
    const formRules = {
      sign_name: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error("请完善继续教育名称"));
            } else {
              callback();
            }
          }
        }
      ],
      recommend_end_date: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("选择审核截止日期"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      saveContact: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (this.testContact === false) {
              callback(new Error("联系人名单内容有误"));
            } else {
              callback();
            }
          }
          // trigger: "change"
        }
      ],
      hours: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("请选择学时"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      video_template: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("请选择学习视频模板"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      date_limit: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("请选择本次继续教育执照有效期"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      trainRange: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("请选择培训日期区间"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      classRange: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("请选择开班月份区间"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      intro: [
        {
          required: false,
          message: '请填写继续教育介绍',
          trigger: 'blur'
        }
      ]
    };
    const nameFormRules = {
      year: [
        {
          validator: (rule, value, callback) => {
            if(this.nameData.ifCustom) {
              callback();
            } else {
              if (!value) {
                callback(new Error("请选择年份"));
              } else {
                callback();
              }
            }
          },
          trigger: "change",
        }
      ],
      custom: [
        {
          validator: (rule, value, callback) => {
            if(this.nameData.ifCustom) {
              if (!value) {
                callback(new Error("请填写继续教育名称"));
              } else {
                if(value.length > 50){
                  callback(new Error("请输入50以内的字符"));
                }else{
                  callback();
                }
              }
            } else {
              callback();
            }
          },
          trigger: "blur",
        }
      ]
    };
    const quarterList = [
      { value: "上半年", key: "上半年" },
      { value: "下半年", key: "下半年" }
    ];
    return {
      backComfim: false,
      ifContactDiaShow: false,
      ifNameDiaShow: false,
      testContact: false,
      submitDisabled: false,
      tipsFlag: false,
      videoTemplateList: [],
      fileUpParam: {},
      contactData: {
        contactInfoList: [{ name: "", mobile_phone: "", email: "", id: 1 }]
      },
      fileLimitNum: 3,
      formRules,
      nameFormRules,
      validatePhone,
      validateEmail,
      editorOption,
      quarterList,
      // highClassLevelList : ([{ key: "D级助理", value: "E" }, { key: "D级", value: "D" },]).concat(highClassLevelList),
      highClassLevelList : classLevelListForCoachAndGoalkepper,
      enroll_type_list,
      education_type:'',
      vuescrollOpt: createScrollOpt(),
      disScrollOpt: createScrollOpt(true),
      fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
      formData: {
        class_level: '',
        education_type:'continue_education', // 目前只有这一种
        sign_name: "",
        status:"",
        hours:"",
        trainRange: null,
        intro: "",
        video_template:"",
        edu_id:0,
        date_limit:""
      },
      
      nameData: {
        year: "",
        quarter: "",
        times: 1,
        custom: "",
        ifCustom: false
      },
      ajaxStatus: ""
    }
  },
  methods: {
    saveNameData() {
      this.$refs["nameDialogForm"].validate(valid => {
        if (valid) {
          const { year, times, custom, ifCustom } = this.nameData;
          if (ifCustom) {
            this.formData.sign_name = custom;
          } else {
           
            const { education_type, class_level } = this.formData;
            this.formData.sign_name = `${year}年${this.getUnitName( education_type, class_level )}第${times}次${
                this.getlevel(this.formData.class_level)
                }${this.getEnrollTypeName(education_type)}`
          }
          this.ifNameDiaShow = false;
          this.$refs["mainForm"].validateField("sign_name");
        } else {
          return false;
        }
      });
    },
    getUnitName(education_type, class_level) {
      let res = '';
      if((education_type === 'continue_education')) {
        res = '亚足联-中国足协';
      } else {
        res = '亚足联-中国足协'
      }
      return res;
    },
    
    getlevel(level){
      // if (level==='PRO' ||level==='0'||level==='P' ){
      //   return '职业级'
      // }
      // if(level==='E'){
      //   return 'D级助理'
      // }
      switch(level) {
        case 'PRO':
        case '0':
        case 'P':
          return '职业级';
          break;
        case 'E':
          return 'D级助理';
          break;
        case 'GC':
          return '守门员C级';
          break;
        case 'GB':
          return '守门员B级';
          break;
        case 'GA':
          return '守门员A级';
          break;
        case 'F1':
          return '体能L1级';
          break;
        default:
          return level+"级"
      }
    },

    getEnrollTypeName(education_type) {
      switch(education_type) {
        case 'goalkeeper_education':
        case 'continue_education':
          return '教练员继续教育培训';
          break;
        default:
          return '教练员继续教育培训';
      }
    },
    startClass(statu) {
      if (this.submitDisabled) return;
      this.$refs["mainForm"].validate(valid => {
        if (valid) {
          this.ajaxStatus = statu;
          this.tipMsg = statu === 'Edit' ? '请确认是否暂时保存？' : '请确认是否保存并进入下一步？'
          this.tipsFlag = true;
        } else {
          this.$message.error("必填项不能为空");
        }
      })
    },
    hideTipsDialog(bool, sure) {
      if (sure) {
        // 提交数据
        this.submit();
        return;
      }
      this.tipsFlag = bool;
    },
    backComfimDialog(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        if(this.formData.edu_id){ // 编辑回详情
          this.$router.push({
            path: 'education_detail',
            query: {
              edu_id: this.formData.edu_id,
              type:"edit"
            }
          })
        }else{ // 添加 回列表
          this.$router.push({
            path: 'education_train_list',
          })
//          this.$router.go(-1);
        }
        
      }
    },
    beforeUpload(file) {
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error("文件大小不能超过200M!");
        return false;
      }
      if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
        this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件!");
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
    isUping() {
      this.submitDisabled = true;
    },
    uploadError() {
      this.submitDisabled = false;
    },
    uploadSuccess(res) {
      this.submitDisabled = false;
      if (Number(res.status) === 0) {
        this.formData.files.push({ url: res.result.document_url, name: res.result.document_name })
      } else {
        this.$nextTick(() => { });
        this.$message.error(res.msg);
      }
    },
    fileRemove(file, fileList) {
      this.formData.files = fileList;
    },
    fileExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 ${this.fileLimitNum} 个文件，本次选择了 ${
        files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
  },
  computed: {
    trainRangeOpt() {
      return {
        disabledDate: time => {
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        }
      };
    },
    
    yearOpt() {
      return {
        disabledDate: time => {
          return time.getFullYear() < new Date().getFullYear();
        }
      };
    }
  },
  watch: {
    testContact: {
      handler: function(val) {
        this.$refs["mainForm"].validateField("saveContact");
      }
    }
  },
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-tips": () => import("@/components/Tips/Dialog")
  }
}
